import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';

export default class extends Controller {
  connect(){
    this.updateTotals();
  }
  updateTotals(event) {
    var total = _.sumBy($(this.element).find('.or-total'), function(o) { return +$(o).val(); });
    var grossweight = _.sumBy($(this.element).find('.or-gross-weight'), function(o) { return +$(o).val(); });
    var netweight = _.sumBy($(this.element).find('.or-net-weight'), function(o) { return +$(o).val(); });
    var pricePerGram = total/netweight;
    
    $(this.element).find('#operation-total').html(formatMoney(total));
    $(this.element).find('#operation-gross-weight').html(formatWeight(grossweight)+' gr');
    $(this.element).find('#operation-net-weight').html(formatWeight(netweight)+' gr');
    $(this.element).find('#operation-price-per-gram').html(formatMoney(pricePerGram)+'/gr');
    console.log('updateTotals', total, grossweight, netweight, pricePerGram);
  }
}
